<template>
  <v-container v-if="!isLoading" fluid>
    <v-row>
      <v-tabs v-model="tab">
        <v-tab
            @click="() => changePage(item)"
            v-for="item in items"
            v-if="isNeedToShow(item)"
            :key="item.tab">{{item.tab}}
        </v-tab>
        <v-tabs-slider color="blue darken-1" />
      </v-tabs>
    </v-row>

    <v-row class="mt-4 pb-1">
      <h5 class="mb-0 header">
        {{plant.species}}{{plant.russianName ? ' - ' + plant.russianName : ''}}{{plant.barcode ? ' (' + plant.barcode + ')' : ''}}
      </h5>
      <div class="horizontal-rule"/>
    </v-row>

    <GeneralTab
        v-if="items[0].visible && !isLoading"
        :plant="plant"
    />
    <OriginalLabelPhotoComponent
        v-if="items[1].visible && !isLoading"
        :plant="plant"
    />
    <MapComponent
        v-if="items[2].visible && !isLoading"
        :coords="plant.gps"
        :label="plant.labelText"
    />
    <ExhibitPhotos
        v-if="items[3].visible && !isLoading"
        :species="plant.species"
        :taxonomy="plant.taxonomy"
        :label-name="plant.labelName"
    />
    <StorageComponent
        v-if="items[4].visible && !isLoading"
        :genus-index="plant.index"
    />

    <CitationTab v-if="items[5].visible && !isLoading" :barcode='plant.barcode' :id='plant.id' />
  </v-container>
  <LoadingModal v-else :is-loading="isLoading" custom-text="Идет загрузка образца"/>
</template>

<script>
import GeneralTab from "@/components/ExhibitPageComponents/GeneralTab";
import OriginalLabelPhotoComponent from "@/components/ExhibitPageComponents/OriginalLabelPhotoComponent.vue";
import MapComponent from "@/components/ExhibitPageComponents/MapComponent";
import ExhibitPhotos from "@/components/ExhibitPageComponents/ExhibitPhotos";
import StorageComponent from "@/components/ExhibitPageComponents/StorageComponent";
import LoadingModal from "@/components/UI/LoadingModal";
import {fetchOneExhibit} from "@/services/exhibitAPI";
import CitationTab from '@/components/ExhibitPageComponents/СitationTab.vue';

export default {
  name: "ExhibitPage",
  components: { CitationTab, StorageComponent, ExhibitPhotos, MapComponent, GeneralTab, LoadingModal, OriginalLabelPhotoComponent},

  data () {
    return {
      tab: 'общее',
      items: [
        {tab: 'общее', visible: true, gps: true, targetType: 'ALL'},
        {tab: 'оригинальная этикетка', visible: false, gps: true, targetType: 'HIGHER_PLANT'},
        {tab: 'карта', visible: false, gps: true, targetType: 'ALL'},
        {tab: 'фото вида в природе', visible: false, gps: true, targetType: 'ALL'},
        {tab: 'место хранения', visible: false, gps: true, targetType: 'ALL'},
        {tab: 'цитирование', visible: false, gps: true, targetType: 'ALL'},
      ],
      plant: {},
      isLoading: true,
    }
  },
  methods: {
    changePage (item) {
      this.items.forEach((tab) => {
        tab === item ? tab.visible = true : tab.visible = false
      })
    },
    isNeedToShow(item) {
      return item.gps && (item.targetType === 'ALL' || item.targetType === this.plant.plantType);
    }
  },

  async created() {
    await fetchOneExhibit(this.$route.params.id).then(data => this.plant = data)
    if (this.plant.gps.longitude === "") {
      this.items[2].gps = false
    }
  this.isLoading = false
  },
}
</script>

<style scoped>

</style>